import { SxProps, Theme } from '@mui/material';

export const slidesContainerSx: SxProps<Theme> = {
	display: 'flex',
	gap: '40px',
};

export const slideSx: SxProps<Theme> = {
	flex: 1,
	height: '750px',
};
